import { Icon } from './Icon';

interface ErrorBannerProps {
  message: string | null;
  className?: string;
}

export default function ErrorBanner({ message, className = '' }: ErrorBannerProps) {
  if (!message || message.trim() === '') {
    return null;
  }

  return (
    <div
      className={`mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl flex items-center gap-3 text-red-600 dark:text-red-400 ${className}`}
    >
      <Icon name="error" />
      <span className="text-sm font-bold">{message}</span>
    </div>
  );
}
